var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-5a99fbdb-cbed-4ea0-a19b-42a003b55330",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-fae2164a-42a1-46f2-a40b-2399967aa943 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-fae2164a-42a1-46f2-a40b-2399967aa943",
    d: "M23.05,16.16c0-.59-.05-1.02-.15-1.47h-6.75v2.67h3.96c-.08.66-.51,1.66-1.47,2.33v.09s2.12,1.65,2.12,1.65h.15c1.36-1.24,2.14-3.09,2.14-5.28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-fae2164a-42a1-46f2-a40b-2399967aa943",
    d: "M16.14,23.19c1.94,0,3.57-.64,4.76-1.74l-2.27-1.76c-.61.42-1.42.72-2.49.72-1.9,0-3.52-1.25-4.09-2.99h-.08s-2.22,1.73-2.22,1.73l-.03.08c1.18,2.35,3.61,3.96,6.43,3.96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-fae2164a-42a1-46f2-a40b-2399967aa943",
    d: "M12.05,17.42c-.15-.45-.24-.93-.24-1.42s.09-.98.23-1.42v-.1s-2.25-1.75-2.25-1.75l-.07.03c-.49.98-.77,2.07-.77,3.23s.28,2.25.77,3.23l2.33-1.81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-fae2164a-42a1-46f2-a40b-2399967aa943",
    d: "M16.14,11.59c1.35,0,2.26.58,2.78,1.07l2.03-1.98c-1.25-1.16-2.87-1.87-4.81-1.87-2.81,0-5.24,1.61-6.43,3.96l2.33,1.81c.58-1.73,2.2-2.99,4.1-2.99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.dfd39b9f9d84167cd9eac0703fae9be4.svg";
export { ForwardRef as ReactComponent };